package org.hs_soft.runmynesto.pages.home.sub_page.template.mvi


import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.errorMessage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError
import org.hs_soft.runmynesto.domain.model.home.closing_reports.CurrencyTypeEnum
import org.hs_soft.runmynesto.domain.model.home.options.CountriesEnum
import org.hs_soft.runmynesto.domain.model.home.product.products_list_model.ProductItem
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.model.home.template.TemplateInfoHeaderEnum
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.ArticleSortEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.ListingLayoutsEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.WaiterDeviceTypeEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.template_category_detail.GetCategory
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.repository.network_datasource.template.tabs.UpdateListOfCategoriesPositionsRepository
import org.hs_soft.runmynesto.domain.requestHandler
import org.hs_soft.runmynesto.domain.usecase.home.GetCompanyProfileIdUseCase
import org.hs_soft.runmynesto.domain.usecase.home.GetSavedCheckOutUseCase
import org.hs_soft.runmynesto.domain.usecase.product.GetImgUrlUseCase
import org.hs_soft.runmynesto.domain.usecase.product.ProductCategoriesUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.UpdateProductUseCase
import org.hs_soft.runmynesto.domain.usecase.template.AddCategoryUseCase
import org.hs_soft.runmynesto.domain.usecase.template.GetTemplateCategoriesUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_checkout.UpdateTemplateCheckoutUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_general.GetDishPictureUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_general.GetSingleTemplateCategoryUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_general.SetGridProductUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_general.UpdateProductsPositionsUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_general.UpdateTemplateCategoryImgUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_general.UpdateTemplateCategoryUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_options.GetPriceLevelsUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_surcharge_in_house.UpdatePriceLevelUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_surcharge_in_house.UpdateSurchargeUseCase
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.BaseViewModel
import org.hs_soft.runmynesto.domain.util.monthModelToDateString
import org.hs_soft.runmynesto.domain.util.parseDateStringToMonthModel

class TemplateViewModel(
    private val requestManager: RequestManager,
    private val getTemplateCategoriesUseCase: GetTemplateCategoriesUseCase,
    private val getSingleTemplateCategoryUseCase: GetSingleTemplateCategoryUseCase,
    private val addCategoryUseCase: AddCategoryUseCase,
    private val updateProductsPositionsUseCase: UpdateProductsPositionsUseCase,
    private val updateTemplateCategoryUseCase: UpdateTemplateCategoryUseCase,
    private val updateTemplateCategoryImgUseCase: UpdateTemplateCategoryImgUseCase,
    private val updateSurchargeUseCase: UpdateSurchargeUseCase,
    private val priceLevelsUseCase: GetPriceLevelsUseCase,
    private val updatePriceLevelUseCase: UpdatePriceLevelUseCase,
    private val updateTemplateCheckoutUseCase: UpdateTemplateCheckoutUseCase,
    private val getDishPictureUseCase: GetDishPictureUseCase,
    private val updateProductUseCase: UpdateProductUseCase,
    private val productCategoriesUseCase: ProductCategoriesUseCase,
    private val getSavedCheckOutUseCase: GetSavedCheckOutUseCase,
    private val getCompanyProfileIdUseCase: GetCompanyProfileIdUseCase,
    private val imgUrlUseCase: GetImgUrlUseCase,
    private val setGridProductUseCase: SetGridProductUseCase,
    private val updateListOfCategoriesPositionsRepository: UpdateListOfCategoriesPositionsRepository,
):BaseViewModel()
{

    private val _state = MutableStateFlow(TemplateState())
    val state : StateFlow<TemplateState> = _state

    private var tempProductCategoryList:List<TemplateCategoryModel> = listOf()
    private var tempArticleList:List<ProductItem> ?= listOf()
    private var tempCheckoutList: List<Children>? = listOf()

    override fun clear() {
        super.clear()
        requestManager.cancelAll()
    }

    init {
        setCurrencyType()
    }



    private fun setCurrencyType(){
        val result=getCompanyProfileIdUseCase()
        _state.value=_state.value.copy(
            companyProfileId=result
        )
        if (result== CountriesEnum.SWITZERLAND.id){
            _state.value=_state.value.copy(
                currencyType=CurrencyTypeEnum.CHF
            )
        }
        else{
            _state.value=_state.value.copy(
                currencyType=CurrencyTypeEnum.EUR
            )
        }
    }


    fun onEvent(event: TemplateEvent) {
        when (event) {

            is TemplateEvent.DismissErrorDialog->{
                _state.value=_state.value.copy(
                    errorInfo = null,
                )
            }
            is TemplateEvent.UpdateArticleRowsCount->{

                updateTemplateCategoryInfo(
                    id = state.value.selectedCategory?.id?:"",
                    dataTitle = ApiUtils.Field.dimensions,
                    dataValue = listOf(event.rowsCount,event.columnsCount)
                )
            }

            is TemplateEvent.SetGridProduct->{
                setGridProduct(
                    categoryId=state.value.selectedCategory?.id?:"",
                    productId=event.productId,
                    position=event.position,
                )
            }

            is TemplateEvent.GetProductListBasedOnCategoryId->{
                getProductListBasedOnCategoryId(
                    categoryId=state.value.selectedCategory?.id,
                )
            }

            is TemplateEvent.ChooseWaiterDeviceType->{
                chooseWaiterDeviceType(type = event.type)
            }

            is TemplateEvent.ChooseWaiterLayoutType->{
                _state.value=_state.value.copy(
                    selectedWaiterLayoutType = event.type
                )
            }


            is TemplateEvent.SelectWaiterDeviceType->{
                _state.value=_state.value.copy(
                    selectedWaiterDeviceType = event.type,
                )
            }

            is TemplateEvent.SetFilterTemplateItemsComponentStatus->{
                _state.value=_state.value.copy(
                    showTemplateItemsFilterComponentDialog = event.status
                )
            }
            is TemplateEvent.SubmitTemplateFilterItems->{
                submitTemplateFilterItems(type=state.value.selectedTemplateFilterItemsType)
            }
            is TemplateEvent.SelectTemplateFilterType->{
                _state.value=_state.value.copy(selectedTemplateFilterItemsType = event.type)
            }

            is TemplateEvent.SetLocalCategoryImg->{
                _state.value=_state.value.copy(
                    imageAiGeneratorUrl=event.url,
                )
            }
            is TemplateEvent.GetTemplateCategoryList ->{
                getTemplateCategoryList( )

            }
            is TemplateEvent.OnTemplateCategoryClick->{
                onTemplateCategoryClick(
                    id=event.id,
                    callBack=event.switchToSecondPage,
                )
            }

            is TemplateEvent.AddNewProductToArticleList->{
                addNewProductToArticleList(
                    dataTitle = ApiUtils.Field.categoryId,
                    dataValue = state.value.selectedCategory?.id?:"",
                    selectedProductId = event.id
                )
            }

            is TemplateEvent.OnSubmitNewImage-> {
                updateTemplateImage(
                    id=event.id,
                    img=event.url,
                )
            }

            is TemplateEvent.OnAddToArticleIconClick->{
                onAddToArticleIconClick(query = state.value.searchedProductValue)

            }

            is TemplateEvent.OnUpdateTemplateCategoryInfo->{
                updateTemplateCategoryInfo(
                    id = event.id,
                    dataTitle = event.dataTitle,
                    dataValue = event.dataValue,
                )
            }

            is TemplateEvent.GetCheckoutData -> {
                getCheckoutData(   )
            }

            is TemplateEvent.UpdateTemplateCategoryListAfterDragDrop->{
                updateTemplateCategoryListAfterDragDrop(
                    newList = event.newList,
                    idsList=event.idList,
                    dataTitle = ApiUtils.Field.position,
                    positionList = event.positionList,
                )
            }
            is TemplateEvent.UpdateCategoryBasedProductListAfterDragDrop->{
                updateCategoryBasedProductsListAfterDragDrop(
                    idsList=event.idList,
                    productIdList=event.productIdList,
                    categoryId = state.value.selectedCategory?.id?:"",
                    positionList = event.positionList,
                )
            }
            is TemplateEvent.RefreshTemplateCategoriesList ->{
                _state.value=_state.value.copy(
                    selectedTemplateFilterItemsType = GridItemsFilterEnum.ACTIVE_ITEMS
                )
                getTemplateCategoryList(  )
            }

            is TemplateEvent.UpdateCheckout -> {
                updateTemplateCheckout(
                    dataValue = event.dataValue,
                    id = state.value.selectedCategory?.id ?: "",
                )
            }

            is TemplateEvent.OnSearchCheckoutItems -> {
                searchCheckoutItems(value = event.value)

            }

            is TemplateEvent.GetPriceLevels->{
                getPriceLevels()
            }
            is TemplateEvent.UpdatePriceLevel->{
                updatePriceLevel(
                    index = event.index,
                    id=state.value.selectedCategory?.id?:"",
                )
            }

            is TemplateEvent.UpdateSurcharge->{
                updateSurcharge(
                    id=state.value.selectedCategory?.id?:"",
                    dataValues=event.values,
                    dataTitle=event.title,
                )
            }

            //Add Record
            is TemplateEvent.OnAddRecordIconClick->onAddRecordIconClick()

            is TemplateEvent.OnBackGroundClick->{
                dismissDialogs()
            }


            is TemplateEvent.OnAddProductToArticleDialogBackgroundClick->{
                _state.value=_state.value.copy(
                    showArticleListDialog = false,
                )
            }

            is TemplateEvent.OnCancelAddingCategoryDialogClick->dismissAddCategoryDialog()

            is TemplateEvent.OnChangeRecordName->onChangeRecordName(event.value)

            is TemplateEvent.OnSubmitAddingCategoryDialogClick->{
                onSubmitAddCategoryDialogClick(
                    windowMode=event.windowMode,
                    name=state.value.newRecordName,
                )
            }

            //Searching Articles
            is TemplateEvent.OnSearchArticleInputChange ->{
                onSearchArticleInputChange(
                    value = event.value,
                )
            }

//            is TemplateEvent.OnArticleTitleSortClick ->onArticleTitleSortClick()


            is TemplateEvent.RefreshArticleList -> refreshArticleList()

            //Other
            is TemplateEvent.OnChangePageClick->changePage()


            is TemplateEvent.OnTabClick->onTabClick(event.tab)


            is TemplateEvent.SetCalendarStatus->{
                _state.value=_state.value.copy(showCalendarDialog = event.status)
            }
            is TemplateEvent.OnSelectDate->{
                chooseDate(
                    selectedDate=event.selectedDate,
                    id=state.value.selectedCategory?.id?:""
                )
            }

            is TemplateEvent.OnPalletColorClick->{
                onPalletColorClick(
                    hexColor =event.hexColor
                )


            }

            is TemplateEvent.SetColorPalletStatus->{
                _state.value=_state.value.copy(showColorPalletDialog=event.status)
            }
            is TemplateEvent.SetGenerateAIImgDialogStatus->{
                _state.value=_state.value.copy(
                    showGenerateAIImgDialog = event.status,
                    imageAiGeneratorUrl = null,
                    submitGeneratedImgLoading = false,
                    isImageAiGeneratorLoading = false,
                )
                if (!event.status){
                    getDishPictureUseCase.cancel()
                    updateTemplateCategoryImgUseCase.cancel()

                }

            }

            is TemplateEvent.GenerateTemplateImg->{
                generateTemplateImg(
                    description=event.description,
                )
            }
            is TemplateEvent.OnChangeAiImageDescription->{
                _state.value=_state.value
                    .copy(imageAiGeneratorDescription = event.value)
            }


        }
    }

    private fun dismissDialogs() {
        _state.value=_state.value.copy(
            showAddRecordDialog = false,
            showArticleListDialog = false,
            showColorPalletDialog = false,
            showGenerateAIImgDialog = false,
            showCalendarDialog = false,

        )

    }



    private fun onAddToArticleIconClick(
        query: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    productCategoriesUseCase(
                        searchQuery = query,
                        isActive = null
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        showArticleListDialog = true,
                        searchedProducts = result.data?.cashAssist?.listProducts?.items ?: listOf()
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun setGridProduct(
        categoryId: String,
        productId: String?,
        position: Int,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    setGridProductUseCase(
                        categoryId = categoryId,
                        position = position,
                        productId = productId
                    )
                },
                onSuccess = { result ->
                    if (result.data?.cashAssist?.setGridProduct?.id != null) {
                        getSingleTemplateCategoryData(
                            id = state.value.selectedCategory?.id ?: "",
                            callBack = {}
                        )
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getProductListBasedOnCategoryId(
        categoryId: String?,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    productCategoriesUseCase(
                        categoryId = categoryId,
                        isActive = null
                    )
                },
                onSuccess = { result ->
                    val items = result.data?.cashAssist?.listProducts?.items
                    _state.value = _state.value.copy(articleList = items)
                    tempArticleList = items
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateCategoryBasedProductsListAfterDragDrop(
        idsList: List<String>,
        productIdList: List<String>,
        categoryId: String,
        positionList: List<Int>,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    updateProductsPositionsUseCase(
                        categoryId = categoryId,
                        productIdList = productIdList,
                        positionsList = positionList,
                        idsList = idsList
                    )
                },
                onSuccess = { result ->
                    getSingleTemplateCategoryData(
                        id = state.value.selectedCategory?.id ?: "",
                        callBack = {}
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun generateTemplateImg(
        description: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isImageAiGeneratorLoading = isLoading)
                },
                callRequest = {
                    getDishPictureUseCase(description = description)
                },
                onSuccess = { result ->
                    val imageDataUrl = "data:image/jpeg;base64,$result"
                    _state.value = _state.value.copy(imageAiGeneratorUrl = imageDataUrl)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateSurcharge(
        id: String,
        dataValues: List<Int?>,
        dataTitle: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    updateSurchargeUseCase(
                        id = id,
                        dataTitle = dataTitle,
                        dataValue = dataValues
                    )
                },
                onSuccess = { result ->
                    val updateResult = result.data.cashAssist.updateCategory
                    _state.value = _state.value.copy(
                        selectedCategory = state.value.selectedCategory?.copy(
                            surchargeFrom = updateResult?.surchargeFrom ?: listOf(),
                            surchargeAmount = updateResult?.surchargeAmount ?: listOf(),
                            surchargePercent = updateResult?.surchargePercent ?: listOf()
                        )
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updatePriceLevel(
        id: String,
        index: Int,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    updatePriceLevelUseCase(
                        index = index,
                        id = id
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        selectedPriceLevelIndex = result.data.cashAssist.updateCategory?.priceLevel
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getPriceLevels() {
        if (state.value.priceLevels == null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->

                    },
                    callRequest = {
                        priceLevelsUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            priceLevels = result.data?.cashAssist?.getAppConfigAdditional?.priceLevels
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun updateTemplateCheckout(
        dataValue: MutableSet<String>,
        id: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    updateTemplateCheckoutUseCase(
                        userId = id,
                        dataValue = dataValue
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        selectedCategory = state.value.selectedCategory?.copy(
                            cashRegisterId = result.data.cashAssist.updateCategory?.cashRegisterId ?: listOf()
                        )
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun onSubmitAddCategoryDialogClick(
        name: String,
        windowMode: WindowSizeModeEnum,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(addNewCategoryLoading = isLoading)
                },
                callRequest = {
                    addCategoryUseCase(name = name)
                },
                onSuccess = { model ->
                    _state.value = _state.value.copy(
                        showAddRecordDialog = false,
                        addRecordErrorMessage = "",
                        newRecordName = "",
                        selectedCategory = GetCategory(
                            id = model.data?.cashAssist?.createMutation?.id ?: "",
                            name = model.data?.cashAssist?.createMutation?.name ?: ""
                        ),
                        articleList = listOf(),
                        templateItemImg = null,
                        firstPageActive = windowMode != WindowSizeModeEnum.PHONE
                    )
                    getTemplateCategoryList()
                },
                onError = { result ->
                    _state.value = _state.value.copy(
                        addRecordErrorMessage = errorMessage(result.errors)
                    )
                    showRequestError(result.errors)
                },
                onException = { e ->
                    _state.value = _state.value.copy(
                        addRecordErrorMessage = e.message.toString()
                    )
                    showException(e)
                }
            )
        }
    }

    private fun updateTemplateImage(
        id: String,
        img: String?
    ) {
        if (img != null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(submitGeneratedImgLoading = isLoading)
                    },
                    callRequest = {
                        updateTemplateCategoryImgUseCase(
                            img = img,
                            id = id
                        )
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            imageAiGeneratorUrl = null,
                            showGenerateAIImgDialog = false,
                            templateItemImg = img
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun updateTemplateCategoryInfo(
        id: String,
        dataTitle: String,
        dataValue: dynamic
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    updateTemplateCategoryUseCase(
                        dataTitle = dataTitle,
                        dataValue = dataValue,
                        id = id
                    )
                },
                onSuccess = { result ->
                    val model = result.data?.cashAssist?.updateCategory
                    _state.value = _state.value.copy(
                        selectedDays = model?.weekDays ?: 0
                    )

                    if (dataTitle == ApiUtils.Field.isActive) {
                        tempProductCategoryList = tempProductCategoryList.map { category ->
                            if (category.id == id) {
                                category.copy(isActive = dataValue as Boolean)
                            } else {
                                category
                            }
                        }
                        submitTemplateFilterItems(type = state.value.selectedTemplateFilterItemsType)
                    }

                    if (dataTitle == ApiUtils.Field.name) {
                        _state.value = _state.value.copy(
                            selectedCategory = state.value.selectedCategory?.copy(
                                name = model?.name ?: ""
                            ),
                            imageAiGeneratorDescription = model?.name ?: ""
                        )
                        getTemplateCategoryList()
                    }

                    if (dataTitle==ApiUtils.Field.dimensions){
                        _state.value=_state.value.copy(
                            articleRowsCount=model?.dimensions?.get(0)?:1,
                            articleColumnsCount=model?.dimensions?.get(1)?:1,
                        )
                    }
                    if (dataTitle==ApiUtils.Field.sortId){
                        _state.value=_state.value.copy(
                            selectedArticleSortId = model?.sortId?:""
                        )
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun addNewProductToArticleList(
        dataTitle: String,
        dataValue: String,
        selectedProductId: String
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(
                        loadingProgress = isLoading,
                        addNewCategoryLoading = isLoading
                    )
                },
                callRequest = {
                    updateProductUseCase(
                        dataTitle = dataTitle,
                        dataValue = dataValue,
                        productId = selectedProductId
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        showArticleListDialog = false
                    )
                    getSingleTemplateCategoryData(
                        id = state.value.selectedCategory?.id ?: "",
                        callBack = {}
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getTemplateCategoryList() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(
                        loadingProgress= isLoading //templateCategoryListLoading
                    )
                },
                callRequest = {
                    getTemplateCategoriesUseCase()
                },
                onSuccess = { templateCategoryData ->
                    val sortedCategories = templateCategoryData.data?.cashAssist
                        ?.listCategories?.items?.sortedBy { it.position } ?: listOf()

                    tempProductCategoryList = sortedCategories

                    _state.value = _state.value.copy(
                        templateCategoryList =if (state.value.selectedTemplateFilterItemsType.value== null)
                            sortedCategories else
                        sortedCategories.filter {
                            it.isActive ==state.value.selectedTemplateFilterItemsType.value
                        }
                    )

                    if (sortedCategories.isNotEmpty() && state.value.selectedCategory == null) {
                        onTemplateCategoryClick(
                            id = state.value.templateCategoryList[0].id
                        )
                    }
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }


    private fun getSingleTemplateCategoryData(
        id: String,
        callBack: () -> Unit
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    getSingleTemplateCategoryUseCase(id)
                },
                onSuccess = { result ->
                    val model = result.data?.cashAssist?.getCategory
                    _state.value = _state.value.copy(
                        selectedCategory = model,
                        templateItemImg = model?.img?.url,
                        selectedPriceLevelIndex = model?.priceLevel,
                        selectedDate = parseDateStringToMonthModel(model?.validAfter),
                        selectedPalletColor = model?.color,
                        selectedDays = model?.weekDays ?: 0,
                        imageAiGeneratorDescription = model?.name ?: "",
                        articleRowsCount = model?.dimension?.get(0)?:1,
                        articleColumnsCount = model?.dimension?.get(1)?:1,
                        selectedArticleSortId=model?.sortId?:ArticleSortEnum.AUTO_BY_NAME.sortId
                    )

                    getProductListBasedOnCategoryId(categoryId = model?.id)
                    callBack()
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    suspend fun showImgURL(key: String): String {
        var result = ""
        requestHandler(
            callRequest = {
                imgUrlUseCase(key)
            },
            onSuccess = { url ->
                result = url
            },
            onError = { _ ->
                result = ""
            },
            onException = { e ->
                result = ""
            }
        )

        return result


    }



    private fun chooseWaiterDeviceType(
        type:WaiterDeviceTypeEnum,
    )
    {
        _state.value = _state.value.copy(
            selectedWaiterDeviceType = type,
            selectedWaiterLayoutType = if (type == WaiterDeviceTypeEnum.DESKTOP_WAITER)
                ListingLayoutsEnum.TILES else state.value.selectedWaiterLayoutType
        )
    }

    private fun onPalletColorClick(hexColor:String) {
        if ( hexColor != state.value.selectedPalletColor) {
            _state.value = _state.value.copy(
                selectedPalletColor = hexColor,
                showColorPalletDialog = false
            )


            updateTemplateCategoryInfo(
                id = state.value.selectedCategory?.id ?: "",
                dataTitle = ApiUtils.Field.color,
                dataValue = hexColor,

                )

        }
    }



    private fun submitTemplateFilterItems(type: GridItemsFilterEnum) {
        when(type){
            GridItemsFilterEnum.ALL_ITEMS->{
                _state.value=_state.value.copy(
                    templateCategoryList = tempProductCategoryList,
                    showTemplateItemsFilterComponentDialog=false,
                )
            }

            GridItemsFilterEnum.ACTIVE_ITEMS->{
                _state.value=_state.value.copy(
                    templateCategoryList = tempProductCategoryList.filter {
                        it.isActive?:false
                    },
                    showTemplateItemsFilterComponentDialog=false,
                )
            }
            GridItemsFilterEnum.INACTIVE_ITEMS->{
                _state.value=_state.value.copy(
                    templateCategoryList = tempProductCategoryList.filter {
                        !(it.isActive?:false)
                    },
                    showTemplateItemsFilterComponentDialog=false,
                )
            }
        }



    }

    private fun chooseDate(
        selectedDate: MonthModel,
        id: String,
    ) {
        _state.value = _state.value.copy(
            showCalendarDialog = false,
            selectedDate =  selectedDate,
        )

        updateTemplateCategoryInfo(
            id=id,
            dataTitle = ApiUtils.Field.validAfter,
            dataValue = monthModelToDateString(selectedDate) ,
        )

    }

    private fun searchCheckoutItems(value: String) {
        if (value.isEmpty()) {
            _state.value = _state.value.copy(
                cashList = tempCheckoutList,
                checkOutExpandAll = false
            )
            return
        }

        val searchTerm = value.lowercase()
        val searchedList = tempCheckoutList?.mapNotNull { model ->
            val filteredChildrenX = model.children?.mapNotNull { childX ->
                val filteredChildrenXX = childX.children?.mapNotNull { childXX ->
                    val filteredChildrenXXX = childXX.children.filter { childXXX ->
                        childXXX.name?.lowercase()?.contains(searchTerm) == true
                    }

                    if (childXX.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenXXX.isNotEmpty()) {
                        childXX.copy(children = filteredChildrenXXX)
                    } else null
                }

                if (childX.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenXX?.isNotEmpty() == true) {
                    childX.copy(children = filteredChildrenXX)
                } else null
            }

            if (model.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenX?.isNotEmpty() == true) {
                model.copy(children = filteredChildrenX)
            } else null
        }

        _state.value = _state.value.copy(
            cashList = searchedList,
            checkOutExpandAll = true
        )
    }

    private fun getCheckoutData(  ) {
        launch {
            if (state.value.cashList==null){

                val result=getSavedCheckOutUseCase()

                _state.value=_state.value.copy(
                    cashList = result?.data?.cashAssist?.children
                )
                tempCheckoutList=state.value.cashList
            }

        }

    }

    private fun onTabClick(tab: TemplateInfoHeaderEnum) {
        _state.value=_state.value.copy(
            selectedTab=tab
        )

    }


    private fun  updateTemplateCategoryListAfterDragDrop(
        newList: List<dynamic>,
        idsList: List<String>,
        dataTitle: String,
        positionList: List<Int>,
    ) {
        _state.value=_state.value.copy(
            templateCategoryList = newList
        )

        idsList.forEachIndexed { index,item ->
            updateTemplateCategoryInfo(
                id = item,
                dataTitle = dataTitle,
                dataValue = positionList[index],
            )
        }

        _state.value=_state.value.copy(
            templateCategoryList = state.value.templateCategoryList
                .sortedBy { it.position }
        )

    }


    private fun onChangeRecordName(value: String) {
        _state.value=_state.value.copy(
            newRecordName = value
        )
        checkAddRecordSubmitClickable()
    }

    private fun checkAddRecordSubmitClickable(){
        if (state.value.newRecordName.isNotEmpty()){
            _state.value=_state.value.copy(
                isAddNewRecordSubmitClickable = true
            )
        }else _state.value=_state.value.copy(
            isAddNewRecordSubmitClickable = false
        )
    }

    private fun dismissAddCategoryDialog() {
        _state.value=_state.value.copy(
            showAddRecordDialog = false,
            addNewCategoryLoading = false,
            addRecordErrorMessage =""
        )
        addCategoryUseCase.cancel()
        getTemplateCategoriesUseCase.cancel()

    }

    private fun onAddRecordIconClick() {
        _state.value=_state.value.copy(
            showAddRecordDialog = true
        )
    }


    private fun onTemplateCategoryClick(
        id: String,
        callBack: () -> Unit={},
    ) {
        if (id!=state.value.selectedCategory?.id){

            getSingleTemplateCategoryData(
                id=id,
                callBack={
                    callBack()
                }
            )


        }else callBack()

    }



    private fun changePage() {
        _state.value=_state.value.copy(
            firstPageActive = !_state.value.firstPageActive
        )
    }

    private fun refreshArticleList() {
        _state.value=_state.value.copy(
            articleList = tempArticleList,
            showArticleTitleSortIcon = false,
        )

    }



    private fun onSearchArticleInputChange(
        value: String,
    ) {
        _state.value=_state.value.copy(
            searchedProductValue=value,
            articleList = tempArticleList,
        )
        val filteredItems=state.value.articleList?.filter {
            it.name?.lowercase()?.contains(value.lowercase()) == true
                    || it.code.toString().lowercase().contains(value.lowercase())
        }
        _state.value=_state.value.copy(
            articleList = filteredItems
        )

    }

    private fun showRequestError(result:List<GeneralError?>?) {
        _state.value = _state.value.copy(
            errorInfo = errorMessage(result)
        )
    }
    private fun showException(e: Exception) {
        if (!e.toString().contains(ApiUtils.Status.ERR_401)){
            _state.value = _state.value.copy(
                errorInfo = e.message.toString()
            )
        }
    }



}
